export const urls = {
  GET_MASINA_ZA_ID: 'Masine/vrati_masinu_za_id',
};
